import io from 'socket.io-client';
import { Observable } from 'rx';
import { configs } from '../configs';
import _ from 'lodash';

const $sockets = {};
const $subscribedTopics = {};

export function getSocket(host) {
  if (!$sockets[host]) {
    $sockets[host] = io.connect(host);
    $sockets[host].on('error', (e) => {
      console.error('SocketProxy Error', e);
    });
    $sockets[host].on('connect', () => {

      Object.keys($subscribedTopics)
            .filter((x) => $subscribedTopics[x].host === host)
            .forEach((x) => {
              const {config} = $subscribedTopics[x];
              $sockets[host].emit('subscribe', config,
                () => console.log(`Restored subscription to ${config.url}`));
            })
    });
    $sockets[host].on('disconnect', () => console.log(`Socket disconnected (${host})`));
  }
  return $sockets[host];
}

function messageJson(msg, url) {
  try {
    return JSON.parse(msg)
  }
  catch(ex) {

    return null;
  }
}

export function socketObservable(ctx, host, url, timeframe) {
  const socket = getSocket(host);


  const config = {
    url,
    interval: timeframe
  };
  socket.emit('subscribe', config);

  $subscribedTopics[url] = {config, host};



  return Observable.create((observer) => {
    socket.on(url, (msg) => {
      if(msg && msg.length > 0) {
        // console.log(msg)
        const json = messageJson(msg, url);
        if(json) {
          if (json.result) {
            observer.next(messageJson(json.result, url));
          }
          else if (json.error) {
            observer.throw(new Error(messageJson(json.error, url)));
          }
          else {
            observer.throw(new Error({error: 'Undefined Error', message: json}));
          }
        }
        else {
          observer.throw(new Error({error: 'Undefined Error', message: 'NULL response'}));
        }
      }
    });

    return () => {
      observer.completed();

      socket.emit('unsubscribe', {
        url
      });
      delete $subscribedTopics[url];
    }
  });
}

let activeSubscriptions = {};

export function setUpSocket(ctx, url, streamId, pollingTime, callBack, overrideUrl = false) {
  const host = configs.resultsHubUrl;
  if (activeSubscriptions[ctx]) {
    if (url !== activeSubscriptions[ctx].url) {
      activeSubscriptions[ctx].subscription.dispose();

    } else {

      return activeSubscriptions[ctx].subscription;
    }
  }

  const absUrl = overrideUrl ? url : /^https?\:/.test(url) ? url : `${configs.bragiUrl}/${url.replace(/^\/+/, '')}`;

  const socket = socketObservable(ctx, host, absUrl, pollingTime);
  if (socket) {
    const subscription = socket.subscribe((msg) => {

      callBack(msg);
    });

    activeSubscriptions[ctx] = {
      subscription,
      url
    };

    return subscription;
  }
}

export function removeSubscriptions() {

  _.map(activeSubscriptions, (ctx) => {
    ctx.subscription && ctx.subscription.dispose();
  });
  activeSubscriptions = {};
}




/** WEBPACK FOOTER **
 ** ./data/SocketObservable.js
 **/